module.exports = __webpack_public_path__ + "img/user.f84970b3.png";